import { KeyValueModel } from "@ifaa-components/ui-components";
import { FormGroupState } from "ngrx-forms";
import { AccessYourSuperDrawdownModel, AccessYourSuperPaymentDetailSectionModel } from "src/app/model/access-your-super-custom-sections.model";
import { InvestmentItemModel } from "src/app/model/investment-item.model";

export interface IAccessYourSuperPensionCommutationsComponentState {
    model:AccessYourSuperPaymentDetailSectionModel;
    form:FormGroupState<AccessYourSuperPensionCommutationsForm>;
    fullAmountRadioOptions:KeyValueModel[];
    taxOptions:KeyValueModel[];
    savedFormData:Date
}

export class AccessYourSuperPensionCommutationsForm extends AccessYourSuperDrawdownModel{
    paymentType:number=0;
    fullAmountSelection:number=0;
    partialAmountSpecified:number=0;
    isBeforeTax:boolean=true;
    isPermanentlyRetired:boolean=true;
    partialWithdrawalSelection:boolean=false;
    investmentOptionDrawdown:InvestmentItemModel[] = [];
    unrestrictedNonPreservedAmount:number=0;
    isTtr:boolean=false;
}